.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.label {
  font-size: 14px;
  font-weight: 700;
}

.input {
  width: 100%;
  min-height: 52px;
  padding: 0 14px;
  border: var(--outline);
  border-radius: var(--radius-control);
  background: var(--surface);
  font-size: 17px;
}

/* A refused field keeps the ink outline and gains a thicker error one, so
 * the state does not rest on colour alone: the message below says it too. */
.input[aria-invalid='true'] {
  border-color: var(--error);
  box-shadow: 0 0 0 1px var(--error);
}

.hint {
  font-size: 13px;
  color: var(--ink-3);
}

.error {
  font-size: 14px;
  font-weight: 600;
  color: var(--error);
}
